// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"a7e2f40f","611":"9ba1d67c","971":"aec6dd36"}[chunkId] + ".chunk.css";
};